import React from 'react';
import { Box, MenuItem, MenuList } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LaunchIcon } from '../../../lib/icons';

export const LegalItems: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box className="flex flex-col py-3 gap-y-4">
      <MenuList>
        <MenuItem
          className="flex flex-row mb-3 pl-6"
          onClick={() => window.open(`https://pxtra.de/datenschutz-plattform`, '_blank')}
        >
          {t('company:DATA_PROTECTION')}
          <LaunchIcon className="ml-1" />
        </MenuItem>
        <MenuItem
          className="flex flex-row mb-3 pl-6"
          onClick={() => window.open(`https://pxtra.de/agb-kunden`, '_blank')}
        >
          {t('company:AGB')}
          <LaunchIcon className="ml-1" />
        </MenuItem>
        <MenuItem
          className="flex flex-row pl-6"
          onClick={() => window.open(`https://pxtra.de/impressum`, '_blank')}
        >
          {t('account:IMPRESSUM')}
          <LaunchIcon className="ml-1" />
        </MenuItem>
      </MenuList>
    </Box>
  );
};
